import React, { useEffect, useState, useRef } from "react";
import WidgetHeader from "../../../../components/Widget/Header";
import { useHistory } from 'react-router-dom'
import { Icon } from '@arnsbogroup/react-voicearchive'

const ProfilesWidget = ({ widget }) => {
  const mounted = useRef(false);
  const history = useHistory()
  const [suppliers, setSuppliers] = useState([]);
  const [title, setTitle] = useState("");

  useEffect(() => {
    mounted.current = true;
    fetch("supplierdashboard/Profiles")
      .then((response) => response.json())
      .then(({data}) => {
        if (mounted.current) {
          setSuppliers(data.suppliers);
        }
      });

    setTitle(widget.widgetId.replace(/_/g, " "));

    return () => {
      mounted.current = false;
    };
  }, []);

  const widget_id = `ID_${widget.widgetId}`;
  return (
    <li
      className="bg-white border m-4 shadow rounded border-gray-400"
      key={widget_id}
      id={widget_id}
    >
      <WidgetHeader widget={widget} widgetTitle={title} />

      <div className="grid grid-cols-3 gap-2 p-2">
        {suppliers.map((supplier) => (
          <div
            className="text-primary cursor-pointer bg-gray-50 hover:bg-gray-100 p-2 rounded truncate"
            onClick={() => history.push(`/talent/${supplier.uid}/profile`)}
          >
            {!!(+supplier.onboarded) &&
              <Icon 
              icon={['fa', 'check']}
              title={`${supplier.userid} rates are set.`}></Icon>
            }
            {supplier.userid}
          </div>
        ))}
      </div>
    </li>
  );
};

export default ProfilesWidget;